<template>
  <div style="padding-top: 100px;">
    <banner></banner>
    <block :title="lang[__lang].introduce" style="margin-top: 20px;">
      <div class="main-box">
        <el-image :src="require('../../assets/img/index_kyzx.png')"></el-image>
        <div class="list">
          <div 
            v-for="(item, index) in content.e_center"
            :key="index"
            :class="'list-item '+item.active"
            @mouseover="mouseover(index, 'e_center')"
          >
            <router-link style="color:#444; text-decoration: none;" :to="item.link">
              <div class="icon text-center">
                <el-image :src="item.icon"></el-image>
              </div>
              <h4 class="text-center" style="height: 24px">{{item.title}}</h4>
              <el-image class="imgbox" style="width: 100%;" :src="item.cover"></el-image>
              <ul style="margin: 40px auto 16px auto;padding-left:40px">
                <li v-for="(li, num) in item.list" :key="num">
                  {{li}}
                </li>
              </ul>
              <div class="footer">LINGNAN BIG DATA INSTITUTE</div>
            </router-link>
          </div>
        </div>
      </div>
    </block>
    <block :title="lang[__lang].about" type="bgr" style="margin-top: 100px;">
      <div class="main-box">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-image style="width: 100%;" :src="require('../../assets/img/jianjie01.jpg')"></el-image>
          </el-col>
          <el-col :span="12">
            <div>
              <p style="margin: 20px 40px 10px; line-height: 2.2; text-indent: 2em;" v-for="(item, index) in content.about" :key="index">{{item}}</p>
            </div>
            <div class="text-center" style="margin-top: 50px;">
              <router-link :to="'/'+__lang+'/about/brief'">
              <el-button class="morebox" type="default">MORE +</el-button>
              </router-link>
            </div>
          </el-col>
        </el-row>
      </div>
    </block>
    
    <block :title="lang[__lang].product" style="margin-top: 100px;">
      <div class="main-box">
        <el-row :gutter="16">
          <el-col v-for="(item, index) in content.product" :key="index" :span="8">
            <router-link :to="item.link">
              <el-card
                class="yw"
                shadow="never"
                :body-style="{ padding: '0px' }">
                <img :src="item.bg" class="image">
                <div @mouseover="mouseover(index, 'product')" :class="'text-center y-mark '+item.active">
                  <img :src="item.icon" class="icon icon1">
                  <img :src="item.active_icon" class="icon icon2">
                  <p>{{item.title}}</p>
                  <p>{{item.desc}}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>
    </block>
    
    <block :title="lang[__lang].news" style="margin-top: 100px;" type="bgr">
      <div class="main-box">
        <el-row :gutter="140">
          <el-col :span="12">
            <div class="yw-list">
              <div class="yw-list-item"
                v-for="(item, index) in news"
                :key="index"
              >
              <router-link style="color:#333;" :to="item.url">
                <div class="yw-list-title">
                  <el-row>
                    <el-col :span="18">
                      <h4>{{item.title}}</h4>
                    </el-col>
                    <el-col :span="6" class="text-right">
                      <span>{{item.datetime}}</span>
                    </el-col>
                  </el-row>
                </div>
                <div class="yw-list-body">
                  <el-row>
                    <el-col :span="18">
                      <p class="ellipsis">{{item.desc}}</p>
                    </el-col>
                    <el-col :span="6" class="text-right">
                      <span class="more">MORE +</span>
                    </el-col>
                  </el-row>
                </div>
              </router-link>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <router-link style="color:#333;" :to="activeNew.url">
            <div class="yw-list">
              <div class="yw-list-item">
                <div class="yw-list-thumb" style="margin-bottom: 20px;">
                  <el-image
                  style="width: 100%; height: 344px"
                  :src="activeNew.thumb"
                  fit="cover"></el-image>
                </div>
                <div class="yw-list-title">
                  <el-row>
                    <el-col :span="18">
                      <h4>{{activeNew.title}}</h4>
                    </el-col>
                    <el-col :span="6" class="text-right">
                      <span>{{activeNew.datetime}}</span>
                    </el-col>
                  </el-row>
                </div>
                <div class="yw-list-body">
                  <el-row>
                    <el-col :span="18">
                      <p>{{activeNew.desc}}</p>
                    </el-col>
                    <el-col :span="6" class="text-right">
                      <span class="more">MORE +</span>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            </router-link>
          </el-col>
        </el-row>
      </div>
    </block>
  </div>
</template>

<script>
import banner from "../../components/banner.vue";
import block from "../../components/block.vue";
import { homeData } from "../../data.js";
import lang from "../../lang.js";
export default {
  name: "home",
  components:{
    banner,
    block
  },
  data() {
    return {
      ...homeData,
      lang
    };
  },
  computed:{
    __lang(){
      return this.$route.params.lang || 'zh-CN';
    },
    content() {
      const lang = this.__lang;
      return this[lang];
    },
    activeNew() {
      if (this[this.__lang].news.length>0) {
        return this[this.__lang].news[0];
      }
      return [];
    },
    news() {
      if (this[this.__lang].news.length>0) {
        return this[this.__lang].news.slice(1);
      }
      return [];
    }
  },
  methods:{
    mouseover(index, key){ 
      const lang = this.__lang;
      this[lang][key] = this[lang][key].map((v, i)=>{
        if (i===index) {
          v.active = "active";
        } else {
          v.active = "";
        }
        return v;
      });
    }
  }
};
</script>

<style lang="less">
body {
  background: url(../../assets/img/bg_banner.png) center 0 no-repeat;
}
.list {
  width: 100%;
  margin-top:0;
  .list-item{
    position: relative;
    float: left;
    width: 275px;
    height: 600px;
    padding-top: 30px;
    border-left: 1px solid #eee;
    border-right: 1px solid #eee;
    margin-right: -1px;
    transition: .8s;
    .footer {
      position: absolute;
      width: 100%;
      text-align: center;
      bottom: 0;
      line-height: 30px;
      color: #ccc;
      font-size: 12px;
    }
    h4 {
      font-size: 18px;
      font-weight: 500;
      color: #333;
    }
    .icon {
      height: 80px;
      margin: auto;
      display: block;
    }
    ul, .imgbox {
      margin-top: 40px;
    }
    ul{
      display: none;
      padding-top: 80px;
      padding-left: 28%;
      width: 270px;
      li {
        padding: 15px 0;
        list-style: circle;
      }
    }
    .imgbox {
      display: block;
    }
    &.active{
      width: 370px;
      ul{
        display: block;
      }
      .imgbox {
        display: none;
      }
    }
  }
}
.yw{
  height: 500px;
  border: none !important;
  background-color: #f9f9f9 !important;
  border-radius: 0 !important;
  position: relative;
  overflow: hidden;
  .image{
    transition: .6s;
  }
  
  &:hover{
    .image{
      transform: scale(1.1);
    }
  }
  .y-mark {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(../../assets/img/index_yewu_tu.png) center bottom no-repeat;
    .icon {
      margin:  60px auto 180px;
    }
    .icon1 {
      display: block;
    }
    .icon2 {
      display: none;
    }
    &.active{
      p {
        color: #d22c1d;
      }
      .icon1 {
        display: none;
      }
      .icon2 {
        display: block;
      }
    }
  }
}
.yw-list {
  h4,p {
    line-height: 1.4em;
    margin: 0;
    padding: 0;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    width: 100% !important;
  }
  
  .yw-list-title {
    margin-bottom: 15px;
    font-size: 18px;
  }
  .yw-list-body {
    font-size: 16px;
    span {
      font-size: 14px;
    }
  }
  .yw-list-item {
    padding-bottom: 30px;
    margin-bottom: 30px;
    border-bottom: 1px solid #eee;
    &:last-child{
      border: 0;
    }
  }
  .yw-list-item.active, .yw-list-item:hover {
    .yw-list-title,
    .more{
      color: #d22c1d;
    }
  }
}

.image {
  width: 100%;
  display: block;
}
</style>
